import { Injectable } from '@angular/core';

import { LocalStoreManager } from './local-store-manager.service';
import { DBkeys } from './db-Keys';
import { Utilities } from './utilities';
import { environment } from '../../environments/environment';

type UserConfiguration = {
  homeUrl: string,
};

@Injectable({
  providedIn: 'root'
})

export class ConfigurationService {
  static readonly appVersion: string = "1.0.0";

  baseUrl = environment.baseUrl || Utilities.baseUrl();
  loginUrl = environment.loginUrl;
  tokenUrl = this.baseUrl + "/token"

  //***Specify default configurations here***
  static readonly defaultHomeUrl: string = "/";
  //***End of defaults***  

  private _homeUrl: string = null;

  constructor(private localStorage: LocalStoreManager) {
    this.loadLocalChanges();
  }

  set homeUrl(value: string) {
    this._homeUrl = value;
    this.saveToLocalStore(value, DBkeys.HOME_URL);
  }
  get homeUrl(): string {
    if (this._homeUrl != null)
      return this._homeUrl;

    return ConfigurationService.defaultHomeUrl;
  }

  private loadLocalChanges() {
    if (this.localStorage.exists(DBkeys.HOME_URL))
      this._homeUrl = this.localStorage.getDataObject<string>(DBkeys.HOME_URL);
  }

  private saveToLocalStore(data: any, key: string) {
    setTimeout(() => this.localStorage.savePermanentData(data, key));
  }

  import(jsonValue: string) {

    this.clearLocalChanges();

    if (!jsonValue)
      return;

    let importValue: UserConfiguration = Utilities.JSonTryParse(jsonValue);

    if (importValue.homeUrl != null)
      this.homeUrl = importValue.homeUrl;
  }

  export(changesOnly = true): string {

    let exportValue: UserConfiguration =
    {
      homeUrl: changesOnly ? this._homeUrl : this.homeUrl
    };

    return JSON.stringify(exportValue);
  }

  clearLocalChanges() {
    this._homeUrl = null;

    this.localStorage.deleteData(DBkeys.HOME_URL);
  }
}
